import $ from 'jquery';
window.jQuery = $;
window.$ = $;

import AOS from 'aos';

AOS.init({
    startEvent: 'DOMContentLoaded',
    duration: 350,
    mirror: false,
    once: true,
    disable: function () {
        var maxWidth = 1190;
        return window.innerWidth < maxWidth;
    },
});

import slick from 'slick-carousel';

import "magnific-popup";

import {hamburger} from './parts/navbar.js';
import {stickycat} from './parts/stickycat.js';
import tiles from './parts/tiles.js';
import {scrollToFixed} from './parts/scroll-to-fixed.js';
import {homeloadmore} from './parts/homeloadmore.js';
import {cookies} from './parts/cookies.js';

//--jquery cookies
require('./plugins/cookies.js');

const source = document.querySelector('body');
source.addEventListener('copy', (event) => {
    const selection = document.getSelection();
    event.clipboardData.setData('text/plain', selection + "\r\n" + "Czytaj dalej na: " + window.location.href);
    event.preventDefault();
});


(function ($) {

    //-- delay function for resizing
    var delay = (function () {
        var timer = 0;
        return function (callback, ms) {
            clearTimeout(timer);
            timer = setTimeout(callback, ms);
        }
    })();

    $(document).ready(function () {

        var body = $('body');

        hamburger();
        tiles();
        scrollToFixed();

        if( body.hasClass('template-home') || body.hasClass('is-category') || body.hasClass('is-tag') || body.hasClass('is-front') ){
            homeloadmore();
        }

        var catmobile_btn = $('#catmobile'),
            catmenu = $('.catdropdown ul.menu');
            catmobile_btn.on('click', function(){
                $(this).toggleClass('is-active');
                catmenu.slideToggle(600);
            });

        $('.likecounter').on('click', function(e){
            e.preventDefault();

            var post_id = $(this).attr('data-id'),
                spancounter = $(this).find('span');

            var dataString = {
                action:'process_like_click',
                post_id: post_id,
                security: FR.ajax_nonce
            };
    
            $.ajax({
                url:FR.ajax_url,
                data:dataString,
                type: 'POST',
                success: function(data){
                    if( data.passed == true ){
                        var newvalue = parseInt(spancounter.text() ) + 1;
                        $('.likecounter').addClass('liked');
                        $('.spancounter').each(function(){
                            $(this).text( newvalue );
                        });
                    }
                },
                error: function(error){
                    console.log('error');
                }
            });
    
            return false;
        });


        $('.gallery').slick({
            arrows:true,
            autoplay: true,
            autoplaySpeed: 5000,
            pauseOnHover:false,
            pauseOnFocus:false,
            pauseOnDotsHover:false,
            zIndex: 7777,
            fade:true,
            dots: false,
            prevArrow:"<button type='button' class='gallery__icon gallery__icon--prev'><i class='icon-angle-left' aria-hidden='true'></i></button>",
            nextArrow:"<button type='button' class='gallery__icon gallery__icon--next'><i class='icon-angle-right' aria-hidden='true'></i></button>"
        });

        // From an element with ID #popup
        $('.open-popup-link').magnificPopup({
            items: {
                src: '#searchpopup',
                type: 'inline'
            },
            mainClass: 'mfp-with-zoom',
            showCloseBtn:false,
            fixedContentPos:true,
            fixedBgPos:true,
            zoom: {
                enabled: true,
                duration: 300,
                easing: 'ease-in-out',
                opener: function(openerElement) {
                    return openerElement.is('a') ? openerElement : openerElement.find('a');
                }
            }
        });

        $('.searchpopup__close').click(function(){
            $.magnificPopup.close();
         });

    });

    $(window).on({
        load:function(){
            cookies();
        },  
        scroll:function(){

            var body = $('body');

            readprogress();
            stickycat()
            
            if( body.hasClass('template-home') || body.hasClass('is-category') || body.hasClass('is-tag') || body.hasClass('is-front') ){
                homeloadmore();
            }

       }
    });

    function readprogress() {
        var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
        var height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        var scrolled = (winScroll / height) * 100;
        var readprogress = document.getElementById('readprogress');
        if( readprogress ){
            readprogress.style.width = scrolled + "%";
        } 
    }

}(jQuery));